import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CsProjectState, CsProjectStore } from './cs-project.store';

@Injectable({ providedIn: 'root' })
export class CsProjectsQuery extends QueryEntity<CsProjectState> {

    constructor(protected store: CsProjectStore) {
      super(store);
    }
  }
